import { Tab } from "@headlessui/react";
// import CommentListing from "components/CommentListing/CommentListing";
import StartRating from "components/StartRating/StartRating";
import React, { FC, Fragment, useEffect, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Label from "components/Label/Label";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "functions/redux/store";
import { checkLogin, errorAlert, logOut, updateMyAvatar, updateMyProfile, updateMyProfileGuide } from "functions/redux/user/action";
import Button from "shared/Button/Button";
import { useHistory } from "react-router";
import Loader from "react-loader-spinner";
import { Link } from "react-router-dom";
import OpenTripListGuide from "./OpenTripListGuide";
import PrivateTripListGuide from "./PrivateTripListGuide";
import { useTranslation } from "react-i18next";
import { MyTrips } from "./MyTrips";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { CameraIcon } from "@heroicons/react/solid";
import NcModal from "shared/NcModal/NcModal";
import { showAlert, uploadIDImg, uploadIDImgUpdate, uploadSelfieIDImg, uploadSelfieIDImgUpdate } from "functions/redux/general/action";
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input'
import '../../styles/myStyle.css';
import FormItem from "components/Form/FormItem";
import { authGet, authJsonPost, getUrl } from "functions/BaseAxios";
import { toast, ToastContainer } from "react-toastify";
import ReactTextareaAutosize from "react-textarea-autosize";
import { getIsShowData, getIsShowLoading, getQuestionGuide, getQuestionTripGuide, getShowItem, setIsShowData, setIsShowLoading, updateShowItem, updateTextQuestion } from "functions/redux/question/action";
import moment from "moment";
import NcDropDown from "shared/NcDropDown/NcDropDown";
import ncNanoId from "utils/ncNanoId";
import toHumanDate from "utils/DateChange";
import Badge from "shared/Badge/Badge";
import ListGiveaway from "containers/PageGiveaway/ListGiveaway";
import { getGiveawayDetailUser } from "functions/redux/giveaway/action";
export interface AuthorPageProps {
    className?: string;
}

const PageProfile: FC<AuthorPageProps> = ({ className = "" }) => {
    let [categories] = useState(["Open Trip", "Private Trip"]);
    const dispatch = useDispatch();
    const { user, general, questionReducer } = useSelector((state: RootStore) => state);

    const history = useHistory();
    const [loading, setLoading] = useState("");
    const [loadingGuide, setloadingGuide] = useState("");
    const [mobileEditProfile, setMobileEditProfile] = useState(false);
    const [displayName, setDisplayName] = useState(user.credential?.profile?.displayName ?? '');
    const [phoneNumber, setPhoneNumber] = useState(user.credential?.profile?.phoneNumber ?? '');
    const [countryNumber, setcountryNumber] = useState(user.credential?.profile?.phoneNumberCountry ?? '');
    const [codeNumber, setcodeNumber] = useState(user.credential?.profile?.phoneNumberCode ?? '');
    const [aboutMe, setAboutMe] = useState(user.credential?.profile?.aboutMe ?? '');
    const [homeBase, setHomeBase] = useState(user.credential?.profile?.homeBase ?? '');
    const [speaking, setSpeaking] = useState(user.credential?.profile?.speaking ?? '');
    const { t } = useTranslation();
    const [isHover, setisHover] = useState(false);
    const [showConfirmation, setShowConfirmation] = React.useState(false);
    const [value, setValue] = useState<any | null>(null);

    const [agencyName, setAgencyName] = useState(user.credential?.guideDetail?.agencyName ?? '');
    const [idCard, setIdCard] = useState(user.credential?.guideDetail?.idCardNo ?? '');
    const [bankName, setBankName] = useState(user.credential?.guideDetail?.bankName ?? '');
    const [accountHolder, setAccountHolder] = useState(user.credential?.guideDetail?.bankAccountHolder ?? '');
    const [swiftCode, setSwiftCode] = useState(user.credential?.guideDetail?.swiftNumber ?? '');
    const [accountNumber, setAccountNumber] = useState(user.credential?.guideDetail?.bankNumber ?? '');
    const [iban, setIban] = useState(user.credential?.guideDetail?.iban ?? '');
    const [phoneNumberGuide, setPhoneNumberGuide] = useState(user.credential?.guideDetail?.phoneNumber ?? '');
    const [countryNumberGuide, setcountryNumberGuide] = useState(user.credential?.guideDetail?.phoneNumberCountry ?? '');
    const [codeNumberGuide, setcodeNumberGuide] = useState(user.credential?.guideDetail?.phoneNumberCode ?? '');
    const [idCardSelfie, setidCardSelfie] = useState(user.credential?.guideDetail?.idCardSelfie ?? '');
    const [idCardImage, setidCardImage] = useState(user.credential?.guideDetail?.idCard ?? '');
    const [tabsIndex, setTabsIndex] = useState<any>(0);
    const [showQuestion, setshowQuestion] = useState<any>(null);
    const [showQuestionData, setshowQuestionData] = useState<any>(null);


    React.useEffect(() => {
        if (user.credential == null) {
            dispatch(checkLogin());


        }
        // if (questionReducer.questionGuide == null) {
        //     dispatch(getQuestionGuide(0))
        // }
        dispatch(getQuestionTripGuide(0))
        updateShowItem(0);
        if (searchParam('q')) {
            setTabsIndex(searchParam('q'))
        }

    }, [user])


    const showQuestionDetail = () => {
        if (getIsShowData()) {
            dispatch(getQuestionGuide(showQuestion, 0))
        }
        return (
            <QuestionShow id={showQuestion} item={questionReducer.questionGuide} trip={showQuestionData} />
        )

    }

    const searchParam = (param: any) => {
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        return urlParams.get(param);
    }

    const tabsListprofile = ["General"];
    if (user.credential.isGuide === '1') {
        tabsListprofile.push("Guide");
    }

    const setphoneFormat = (value: any) => {
        if (value !== undefined) {
            let parse = parsePhoneNumber(value);
            if (parse !== undefined) {
                setPhoneNumber(value);
                setcountryNumber(parse.country);
                setcodeNumber(parse.countryCallingCode);
            }

        }
    }

    const setphoneFormatGuide = (value: any) => {
        if (value !== undefined) {
            let parse = parsePhoneNumber(value);
            if (parse !== undefined) {
                setPhoneNumberGuide(value);
                setcountryNumberGuide(parse.country);
                setcodeNumberGuide(parse.countryCallingCode);
            }

        }
    }

    const logout = async () => {
        await dispatch(logOut());
        history.replace('/')

    }


    const uploadID = async (event: any) => {
        setLoading("imageID");
        var img = await uploadIDImgUpdate(event.target.files[0]);
        if (img.code === undefined) {
            setidCardImage(img.urls[(img.urls).length - 1])
        } else {
            dispatch(errorAlert());
        }
        setLoading("");

    }

    const selfieIDUpload = async (event: any) => {
        setLoading("uploadSelfieID");
        var img = await uploadSelfieIDImgUpdate(event.target.files[0]);
        if (img.code === undefined) {
            setidCardSelfie(img.urls[(img.urls).length - 1])
        } else {
            dispatch(errorAlert());
        }
        setLoading("");
    }

    const submitData = async () => {
        setLoading("submit");
        await dispatch(await updateMyProfileGuide([
            {
                agencyName: agencyName,
                bankNumber: accountNumber,
                bankAccountHolder: accountHolder,
                bankName: bankName,
                idCardNo: idCard,
                phoneNumber: phoneNumberGuide,
                phoneNumberCountry: countryNumberGuide,
                phoneNumberCode: codeNumberGuide,
                id: user.credential.guideDetail.id,
                swiftNumber: swiftCode,
                iban: iban,
                idCard: idCardImage,
                idCardSelfie
            }
        ]))
        toast('Data updated');
        setLoading('');
    }

    const updateAvatar = async (e: any) => {
        setLoading("avatar");
        await dispatch(await updateMyAvatar(e.target.files[0], user.credential?.profile?.id));
        setLoading("");
    }

    const addProduct = () => {
        const select = document.getElementsByClassName('tabProduk')[0].getAttribute('aria-selected');
        if (select === 'true') {
            window.location.href = "/open-trip-add";
        } else {
            window.location.href = "/private-trip-add";
        }

    }
    const style = () => {
        document.querySelector('.PhoneInput')?.querySelector('.PhoneInputInput')?.classList.add("border-0");
    }
    const hoverAvatar = () => {
    }
    const renderSidebar = () => {
        return (
            <div className=" w-full flex flex-col items-center text-center sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8">
                <div className="relative overflow-hidden" >
                    <Avatar
                        imgUrl={user.credential?.profile?.avatar}
                        sizeClass="w-28 h-28"
                    />

                    {loading === "avatar" &&
                        <div className="absolute items-center justify-center flex  w-28 h-28 bg-white bg-opacity-60">
                            <Loader
                                type="Circles"
                                color="#d24e29"
                                height={25}
                                width={25}
                            />
                        </div>}
                    <input
                        type="file"
                        className="absolute inset-0  opacity-0 cursor-pointer"
                        onChange={(e) => updateAvatar(e)}
                    />
                    <span className=" mt-1 text-neutral-500 dark:text-neutral-400 flex align-bottom border-2 rounded-full px-1" style={{ fontSize: 12 }}>Change Profile Picture</span>
                </div>
                {/* <div className="absolute top-0 ml-16 bg-white rounded-full  p-2 " >
                    <CameraIcon height={25} color="gray" />
                </div> */}


                <div className="space-y-3 text-center flex flex-col items-center">
                    <div className="flex flex-row">
                        <h2 className="text-3xl font-semibold">{user.credential?.profile?.displayName}</h2>
                        {parseInt(user.credential?.isGuide) === 1 && (
                            <span className={` bg-teal-500 rounded-full text-white text-xs flex items-center justify-center   w-4 h-4 `} >
                                <i className="las la-check"></i>
                            </span>)}

                    </div>
                    {/* <StartRating className="!text-base" /> */}
                </div>

                <p className="text-neutral-500 dark:text-neutral-400">
                    {user.credential?.profile?.aboutMe ?? "Write something about you"}

                </p>

                <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>

                <div className="space-y-4">
                    {user.credential?.profile?.homeBase &&
                        <div className="flex items-center space-x-4">
                            <div style={{ width: 24 }}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6 text-neutral-400"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                                    />
                                </svg>
                            </div>
                            <span className="text-neutral-6000 dark:text-neutral-300">
                                {user.credential?.profile?.homeBase}
                            </span>
                        </div>}
                    {user.credential?.profile?.speaking && (
                        <div className="flex items-center space-x-4">
                            <div style={{ width: 24 }}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6 text-neutral-400"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                                    />
                                </svg>
                            </div>
                            <span className="text-neutral-6000 dark:text-neutral-300" style={{ textAlign: 'left' }}>
                                {user.credential?.profile?.speaking}
                            </span>
                        </div>)}

                    <button onClick={() => setMobileEditProfile(!mobileEditProfile)} className="flex block md:hidden items-center space-x-4">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-neutral-400"
                            fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                        <span className="text-neutral-6000 dark:text-neutral-300">
                            Edit Profile
                        </span>
                    </button>

                    {parseInt(user.credential?.isGuide) === 1 && (
                        <Link to="/manage-products" className="w-full flex items-center justify-center space-x-2 py-2.5 px-4 bg-primary-6000 hover:bg-primary-700 text-white rounded-xl font-medium text-sm transition-colors">
                            <i className="las la-boxes text-xl"></i>
                            <span>Manajemen Produk</span>
                        </Link>
                    )}

                    <Button className="md:w-min w-full  text-red-800 bg-red-100" onClick={() => setShowConfirmation(true)}>{t('logout')}</Button>
                </div>
            </div >
        );
    };

    const mobileListingRender = () => {
        return (
            <div className="">
                <Tab.Group>
                    <Tab.List className="flex mb-4 relative space-x-1">
                        {["Open Trip", "Private Trip"].map((item) => (
                            <Tab key={item} as={Fragment}>
                                {({ selected }) => (
                                    <button
                                        className={`tabProduk flex-shrink-0 block !leading-none font-medium px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize rounded-full focus:outline-none ${selected
                                            ? "bg-primary-6000 text-secondary-50 "
                                            : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                                            } `}
                                    >
                                        {item}
                                    </button>
                                )}
                            </Tab>
                        ))}
                        <div style={{ position: 'absolute', right: 10 }}>
                            <button onClick={addProduct} className="rounded-full text-secondary-50" style={{ backgroundColor: '#FAB005', padding: 5, height: 35, width: '35px' }}>+</button>
                        </div>
                    </Tab.List>
                    <Tab.Panels>
                        <Tab.Panel className="">
                            <OpenTripListGuide />
                        </Tab.Panel>
                        <Tab.Panel className="">
                            <PrivateTripListGuide />
                        </Tab.Panel>
                    </Tab.Panels>
                </Tab.Group>
            </div>);
    }

    const renderSection1 = (tabIndex: any) => {
        return (
            <div className="listingSection__wrap">
                <div className="hidden md:block">
                    <h2 className="text-2xl font-semibold">{t('welcome_back')}</h2>
                    <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                        {user.credential?.profile?.displayName} ,  {t('manage_ur_profile')}
                    </span>
                </div>
                <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
                <div className="block md:hidden bg-white ">
                    <Tab.Group defaultIndex={tabIndex - 1}>
                        <Tab.List className="flex gap-2  fixed z-10 bottom-0 left-0 space-x-1 overflow-x-auto bg-white w-full p-4">
                            {["Profile", "Trips", "Listing", "Question", 'Giveaway'].map((item) => (
                                <Tab key={item} as={Fragment}>
                                    {({ selected }) => (
                                        <button onClick={() => window.scrollTo(0, 0)}
                                            className={`flex-shrink-0 block !leading-none font-medium px-2 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize rounded-full focus:outline-none ${selected
                                                ? "bg-primary-6000 text-secondary-50 "
                                                : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                                                } `}
                                        >
                                            {item}
                                        </button>
                                    )}
                                </Tab>
                            ))}
                        </Tab.List>
                        <Tab.Panels>
                            <Tab.Panel className="">
                                <div>
                                    {mobileEditProfile ? TabEditProfile() : renderSidebar()}
                                </div>
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <MyTrips />
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <div>
                                    {mobileListingRender()}

                                </div>
                            </Tab.Panel>
                            <Tab.Panel className="">
                                {showQuestion ? (
                                    showQuestionDetail
                                    // <QuestionShow item={showQuestion} />
                                ) : (
                                    <QuestionTripGuide item={questionReducer.questionTripGuide} />
                                )}
                                {/* <QuestionShow item={questionReducer.questionGuide} /> */}
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <ListGiveaway />
                            </Tab.Panel>
                        </Tab.Panels>
                    </Tab.Group>
                </div>

                <div className="hidden md:block">
                    <Tab.Group defaultIndex={tabIndex}>
                        <Tab.List className="flex relative space-x-1 overflow-x-auto">
                            {["Trips", "Profile", "Open Trip", "Private Trip", "Question", "Giveaway"].map((item) => (
                                <Tab key={item} as={Fragment}>
                                    {({ selected }) => (
                                        <button
                                            className={`flex-shrink-0 block !leading-none font-medium px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize rounded-full focus:outline-none ${selected
                                                ? "bg-primary-6000 text-secondary-50 "
                                                : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                                                } `}
                                        >
                                            {item}
                                        </button>
                                    )}
                                </Tab>
                            ))}
                            {/* <div style={{position:'absolute', right:10}}>
                                <button onClick={addProduct} className="rounded-full text-secondary-50" style={{backgroundColor:'#FAB005',padding:5, height:35, width:'35px'}}>+</button>
                            </div> */}
                        </Tab.List>
                        <Tab.Panels>
                            <Tab.Panel className="">
                                <MyTrips />
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <div className="mt-8 ">
                                    {TabEditProfile()}
                                </div>
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <OpenTripListGuide />
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <PrivateTripListGuide />
                            </Tab.Panel>
                            <Tab.Panel className="">
                                {showQuestion ? (
                                    showQuestionDetail
                                    // <QuestionShow item={showQuestion} />
                                ) : (
                                    <QuestionTripGuide item={questionReducer.questionTripGuide} />
                                )}
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <ListGiveaway />
                            </Tab.Panel>
                        </Tab.Panels>
                    </Tab.Group>
                </div>
            </div>
        );
    };

    const renderSection2 = () => {
        return (
            <div className="listingSection__wrap">
                <div className="hidden md:block">
                    <h2 className="text-2xl font-semibold">{t('welcome_back')}</h2>
                    <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                        {user.credential?.profile?.displayName} ,  {t('manage_ur_profile_user')}
                    </span>
                </div>
                <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
                <div className="block md:hidden bg-white">
                    <Tab.Group>
                        <Tab.List className="fixed z-10 bottom-0 left-0 space-x-1 overflow-x-auto bg-white w-full p-4 flex justify-between">
                            {["Profile", "Trips"].map((item) => (
                                <Tab key={item} as={Fragment}>
                                    {({ selected }) => (
                                        <button
                                            className={`flex-1 block !leading-none font-medium px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize rounded-full focus:outline-none ${selected
                                                ? "bg-primary-6000 text-secondary-50 "
                                                : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                                                } `}
                                        >
                                            {item}
                                        </button>
                                    )}
                                </Tab>
                            ))}
                        </Tab.List>
                        <Tab.Panels>
                            <Tab.Panel className="">
                                <div>
                                    {mobileEditProfile ? guideProfileRender() : renderSidebar()}
                                </div>
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <MyTrips />
                            </Tab.Panel>
                        </Tab.Panels>
                    </Tab.Group>
                </div>

                <div className="hidden md:block">
                    <Tab.Group>
                        <Tab.List className="flex relative space-x-1 overflow-x-auto">
                            {["Trips", "Profile"].map((item) => (
                                <Tab key={item} as={Fragment}>
                                    {({ selected }) => (
                                        <button
                                            className={`flex-shrink-0 block !leading-none font-medium px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize rounded-full focus:outline-none ${selected
                                                ? "bg-primary-6000 text-secondary-50 "
                                                : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                                                } `}
                                        >
                                            {item}
                                        </button>
                                    )}
                                </Tab>
                            ))}
                        </Tab.List>
                        <Tab.Panels>
                            <Tab.Panel className="">
                                <MyTrips />
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <div className="mt-8 ">
                                    {TabEditProfile()}
                                </div>
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <OpenTripListGuide />
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <PrivateTripListGuide />
                            </Tab.Panel>
                        </Tab.Panels>
                    </Tab.Group>
                </div>
            </div>
        );
    };


    const TabEditProfile = () => {
        return (
            <Tab.Group>
                <Tab.List className="flex relative space-x-1 overflow-x-auto">
                    {tabsListprofile.map((item) => (
                        <Tab key={item} as={Fragment}>
                            {({ selected }) => (
                                <button
                                    className={`flex-shrink-0 block !leading-none font-medium px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize rounded-full focus:outline-none ${selected
                                        ? "bg-primary-6000 text-secondary-50 "
                                        : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                                        } `}
                                >
                                    {item}
                                </button>
                            )}
                        </Tab>
                    ))}
                </Tab.List>
                <Tab.Panels>
                    <Tab.Panel className="">
                        <div className="mt-8 ">
                            {guideProfileRender()}
                        </div>
                    </Tab.Panel>
                    <Tab.Panel className="">
                        <div className="mt-8 ">
                            {guideProfileGuideRender()}
                        </div>
                    </Tab.Panel>

                </Tab.Panels>
            </Tab.Group>
        )
    }

    const updateProfile = async () => {
        setLoading("updateProfile");
        await dispatch(await updateMyProfile([
            {
                id: user.credential?.profile?.id,
                displayName: displayName,
                phoneNumber: phoneNumber,
                aboutMe: aboutMe,
                homeBase,
                speaking,
                phoneNumberCountry: countryNumber,
                phoneNumberCode: codeNumber
            }
        ]));
        toast('Data updated');

        setLoading("");
    }

    const guideProfileRender = () => {
        return (<div className=" listingSection__wrap">
            <div className="flex-grow mt-2  max-w-3xl space-y-6">
                <div>
                    <Label>{t('name')}</Label>
                    <Input className="mt-1.5" defaultValue={user.credential?.profile?.displayName ?? ''} onChange={(e) => setDisplayName(e.target.value)} />
                </div>
                <div>
                    <Label>{t('phone_number')}</Label>
                    {/* <Input className="mt-1.5" defaultValue={user.credential?.profile?.phoneNumber ?? ''} onChange={(e) => setPhoneNumber(e.target.value)} /> */}
                    <div className="mt-1">
                        <PhoneInput
                            international
                            // defaultCountry="ID"
                            // onCountryChange={(con) => console.log(con)}
                            style={{ border: 0 }}
                            value={phoneNumber}
                            onChange={phone => {
                                let ph = phone;
                                setPhoneNumber(phone);
                                // console.log(phone);
                                setphoneFormat(phone);
                                // if (value) {
                                //   console.log(parsePhoneNumber(value));
                                // }
                            }}
                        />
                    </div>
                </div>


                <div>
                    <Label>{t('about')}</Label>
                    <Textarea placeholder="Tell something about you!" className="mt-1.5" defaultValue={user.credential?.profile?.aboutMe ?? ''} onChange={(e) => setAboutMe(e.target.value)} />
                </div>
                <div>
                    <Label>{t('home_base')}</Label>
                    <Input placeholder="Where is your home base?" className="mt-1.5" defaultValue={user.credential?.profile?.homeBase ?? ''} onChange={(e) => setHomeBase(e.target.value)} />
                </div>
                <div>
                    <Label>{t('speaking')}</Label>
                    <Input placeholder="What are languages you are speaking?" className="mt-1.5" defaultValue={user.credential?.profile?.speaking ?? ''} onChange={(e) => setSpeaking(e.target.value)} />
                </div>
                <div className="flex justify-end space-x-5">
                    <ButtonSecondary onClick={() => setMobileEditProfile(false)}>
                        {t('go_back')}
                    </ButtonSecondary>
                    <ButtonPrimary onClick={updateProfile}>
                        {
                            loading === "updateProfile" ?
                                <Loader
                                    type="Circles"
                                    color="#ffffff"
                                    height={25}
                                    width={25}
                                /> : t('save')
                        }
                    </ButtonPrimary>
                </div>
            </div></div>);
    }


    const QuestionTripGuide: FC<{ item: any }> = ({ item }) => {

        return (
            <div className="">
                <h2 className="block md:hidden text-xl font-semibold mb-2">Question</h2>
                <div className="mt-4"></div>

                {item === null ? (
                    <div className="flex justify-center mb-10">
                        <Loader
                            type="Circles"
                            color="#D24D29"
                            height={25}
                            width={25}
                        />
                    </div>
                ) : item?.map((val: any, index: any) => {
                    let tripName = val.isOpenTrip === '1' ? val.title : val.highlight;
                    let tripType = val.isOpenTrip === '1' ? 'Open' : 'Private';
                    let startDate = moment(val.startTripDate).format('DD MMMM YYYY');
                    let endDate = moment(val.endTripDate).format('DD MMMM YYYY');
                    return (
                        <div key={index} className={`mb-2 nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow `}>
                            <a className="cursor-pointer" key={index} onClick={() => {
                                setshowQuestion(val.id);
                                setshowQuestionData(tripName);
                                setIsShowLoading(true);
                            }}>
                                <div className="flex flex-row" >
                                    <img width={100} src="data:image/jpeg;base64,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" alt="" />
                                    <div className="flex flex-col ml-2 py-2 text-left ">
                                        <div>
                                            <Badge name={tripType} color={val.isOpenTrip === '1' ? 'blue' : 'primary'} />
                                        </div>
                                        <div>
                                            <h4 style={{ fontSize: 16, whiteSpace: 'pre-line', lineBreak: 'anywhere' }} className="mr-2 font-semibold line-clamp-2" >{tripName}</h4>
                                            <div className="flex flex-row">
                                                <span>{startDate}</span>
                                                <span className="mx-2">to</span>
                                                <span>{endDate}</span>
                                            </div>
                                            <span>Total Question : {val.questionCount}</span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    )


                })}
            </div>
        )

    }


    const QuestionShow: FC<{ item: any, trip: any, id?: any }> = ({ item, trip, id }) => {

        const [text, setText] = React.useState<String>('');
        const [loadingAnswer, setLoadingAnswer] = React.useState(false);
        const dispatch = useDispatch();
        const [showButton, setShowButton] = useState(null)
        const [page, setPage] = React.useState<number>(0);
        const [loadingBtn, setLoadingBtn] = useState(false);
        const [pageNumber, setpageNumber] = useState(0)
        const [ShowMore, setShowMore] = useState<any | null>([]);
        const [idAnswerQuestion, setidAnswerQuestion] = useState<number | null>(null);
        const [openModalConfirmationDelete, setOpenModalConfirmationDelete] = React.useState<string | null>(null);


        const sendAnswer = async (idQuestion: any) => {
            setLoadingAnswer(true)
            var data = {
                question: idQuestion,
                text: text
            }

            var send = await authJsonPost(
                data,
                'auth/answer-post'
            )

            if (send.code === 200) {
                setText('');
                updateTextQuestion('');
                dispatch(getQuestionGuide(id, 0))
                setText('');
                updateShowItem(0)
            }
            setLoadingAnswer(false);
        }

        const hardReeset = () => {
            var aa = document.querySelectorAll('textarea');
            aa.forEach(val => {
                val.value = "";
            })
        }

        const loadMore = async () => {
            setLoadingBtn(true);
            updateShowItem(getShowItem() + 1)
            await dispatch(getQuestionGuide(id, getShowItem(), item))
            setLoadingBtn(false);
        }

        const deleteAnswer = async () => {
            setLoadingAnswer(true);
            let result = await authGet('auth/answer/delete/' + idAnswerQuestion);
            if (openModalConfirmationDelete === `${"question"}`) {
                result = await authGet('auth/questions/delete/' + idAnswerQuestion);
            }
            if (result.code == 200) {
                dispatch(getQuestionGuide(id, 0));
                setOpenModalConfirmationDelete(null);
                setLoadingAnswer(false);
            }
        }

        return (
            <div className="mt-4">
                <div className="flex flex-row mb-3">
                    <div className="mr-2">
                        <button onClick={() => {
                            setshowQuestion(null);
                            setIsShowData(true);
                        }}><i className="la la-angle-left" style={{ fontSize: 24 }} /></button>
                    </div>
                    <h4 style={{ fontSize: 16, whiteSpace: 'pre-line', lineBreak: 'anywhere' }} className="mr-2 font-semibold " >{trip}</h4>

                </div>
                {getIsShowLoading() ? (
                    <div className="flex justify-center mb-10">
                        <Loader
                            type="Circles"
                            color="#D24D29"
                            height={50}
                            width={50}
                        />
                    </div>
                ) : item?.map((val: any, index: any) => {

                    let date = new Date();
                    let offset = date.getTimezoneOffset();
                    let dateAnswer = moment(Date.parse(val.created)).add((offset * (-1)), 'm').toNow();
                    let tripName = val.isOpenTrip ? val.title : val.highlight;
                    let tripType = val.isOpenTrip ? 'Open' : 'Private';
                    return (
                        <div key={index}>
                            {/* <div className="flex flex-row mt-2">
                            <Badge name={tripType} color={val.isOpenTrip ? 'blue' : 'primary'}/>
                            <label className="ml-2">{tripName}</label>
                        </div> */}
                            <div className="flex justify-between" style={{ marginTop: 10, alignItems: 'flex-end' }}>
                                <div className="flex w-full">
                                    <Avatar
                                        sizeClass="h-10 w-10 text-lg"
                                        radius="rounded-full"
                                        userName="img"
                                        imgUrl={val.avatar}
                                    />
                                    <div className="ml-2 flex-1">
                                        <div className="flex align-middle" style={{ alignItems: 'center' }}>
                                            <h4 style={{ fontSize: 16 }} className="mr-2" >{val.displayName}</h4>
                                            <h5 style={{ fontSize: 12 }}>{`${toHumanDate(val.created)}`}</h5>
                                        </div>
                                        <label className="font-semibold" style={{ whiteSpace: 'pre-line', lineBreak: 'anywhere' }}>{val.text}</label>
                                        <div className="my-2"></div>
                                        <div className="bg-neutral-100 p-2" style={{ borderRadius: '10px' }}>
                                            {
                                                val['0'].answer.map((ans: any, ians: any) => {

                                                    return (
                                                        ians < 1 ? (
                                                            <div key={ans.id} className="flex  w-full mb-3">
                                                                <Avatar
                                                                    sizeClass="h-10 w-10 text-lg"
                                                                    radius="rounded-full"
                                                                    userName="A"
                                                                    imgUrl={ans.avatar ? ans.avatar : ""}
                                                                />
                                                                <div className="grid ml-2">
                                                                    <div className="flex align-middle" style={{ alignItems: 'center' }}>
                                                                        <h4 style={{ fontSize: 16 }} className="mr-2 font-semibold" >{ans.displayName ? ans.displayName : "Admin"}</h4>
                                                                        <h5 style={{ fontSize: 12 }}>{`${toHumanDate(ans.created)}`}</h5>

                                                                    </div>
                                                                    <p style={{ marginTop: 2, whiteSpace: 'pre-line', lineBreak: 'anywhere' }}>{ans.text}</p>
                                                                </div>
                                                                <div className="flex-1 ">
                                                                    <div className="flex-row " style={{ textAlign: 'right' }}>
                                                                        {user?.credential?.id == ans.uid ? (
                                                                            <NcDropDown data={[{ id: '1', name: `${t('delete')} ${t('answer')}`, icon: "" }]} onClick={(item) => {
                                                                                // deleteAnswer(ans.id);

                                                                                setidAnswerQuestion(ans.id);
                                                                                setOpenModalConfirmationDelete(`${t("answer")}`);
                                                                            }} />
                                                                        ) : <div></div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : <div key={'a' + ians}></div>
                                                    )
                                                }
                                                )
                                            }
                                            <div style={{ display: ShowMore['key' + val.id] && ShowMore['key' + val.id] == 'on' ? 'block' : 'none' }}>
                                                {val['0'].answer.map((ans: any, ians: any) => {

                                                    return (
                                                        ians > 0 ? (
                                                            <div key={ans.id} className="flex  w-full mb-3">
                                                                <Avatar
                                                                    sizeClass="h-10 w-10 text-lg"
                                                                    radius="rounded-full"
                                                                    userName="A"
                                                                    imgUrl={ans.avatar ? ans.avatar : ""}
                                                                />
                                                                <div className="grid ml-2">
                                                                    <div className="flex align-middle" style={{ alignItems: 'center' }}>
                                                                        <h4 style={{ fontSize: 16 }} className="mr-2 font-semibold" >{ans.displayName ? ans.displayName : "Admin"}</h4>
                                                                        <h5 style={{ fontSize: 12 }}>{`${toHumanDate(ans.created)}`}</h5>
                                                                    </div>
                                                                    <p style={{ marginTop: 2, whiteSpace: 'pre-line', lineBreak: 'anywhere' }}>{ans.text}</p>
                                                                </div>
                                                                <div className="flex-1 ">
                                                                    <div className="flex-row " style={{ textAlign: 'right' }}>
                                                                        {user?.credential?.id == ans.uid ? (
                                                                            <NcDropDown data={[{ id: '1', name: `${t('delete')} ${t('answer')}`, icon: "" }]} onClick={(item) => {
                                                                                // deleteAnswer(ans.id);
                                                                                setidAnswerQuestion(ans.id);
                                                                                setOpenModalConfirmationDelete(`${t("answer")}`);
                                                                            }} />
                                                                        ) : <div></div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : <div key={'b' + ians}></div>
                                                    )
                                                }
                                                )}
                                            </div>
                                            <div style={{ display: val['0'].answer.length > 1 ? 'block' : 'none' }} ><a className="cursor-pointer" onClick={() => {
                                                if (ShowMore['key' + val.id] == 'on') {
                                                    setShowMore({ ['key' + val.id]: 'off' });
                                                } else {
                                                    setShowMore({ ['key' + val.id]: 'on' });
                                                }
                                            }}>{ShowMore['key' + val.id] == 'on' ? 'Less more' : `show more (${val['0'].answer.length - 1})`}</a></div>
                                            <div>
                                                <ReactTextareaAutosize key={'v' + val.id} onFocus={() => {
                                                    setShowButton(index);

                                                }} onChange={(e) => setText(e.target.value)} placeholder="Type your answer" minRows={showButton === index ? 3 : 1} className="block w-full text-sm rounded-2xl border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 mb-2" />
                                                {showButton === index ? (
                                                    <div className="flex justify-end">
                                                        <ButtonSecondary key={index} className="mr-2" onClick={() => {
                                                            hardReeset();
                                                            setShowButton(null);
                                                        }}>Cancel</ButtonSecondary>
                                                        <ButtonPrimary className="mt-0" onClick={() => {
                                                            if (text == '') {
                                                            } else {
                                                                updateTextQuestion(text.toString());
                                                                setShowMore(ShowMore);
                                                                sendAnswer(val.id);
                                                            }
                                                        }}>{loadingAnswer ? <Loader
                                                            type="Circles"
                                                            color="white"
                                                            height={25}
                                                            width={25}
                                                        /> : 'Send'}</ButtonPrimary>
                                                    </div>
                                                ) : <></>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full border-b border-neutral-200 dark:border-neutral-700 mt-4"></div>
                        </div>
                    )
                })}
                <div>
                    <ButtonPrimary className="w-full" onClick={() => {

                        loadMore();
                    }}> {loadingBtn ? (
                        <Loader
                            type="Circles"
                            color="white"
                            height={20}
                            width={20}
                        />
                    ) : 'Load more'}</ButtonPrimary>
                </div>

                <NcModal
                    isOpenProp={openModalConfirmationDelete != null}
                    renderTrigger={() => { return (<div></div>); }}
                    modalTitle={'Question'}
                    renderContent={() => (
                        <div>
                            <label>{t('conf_delete')} {openModalConfirmationDelete} ?</label>
                            <div className="flex justify-between">
                                <ButtonSecondary onClick={() => {
                                    setLoadingAnswer(false);
                                    setOpenModalConfirmationDelete(null)
                                }}>No</ButtonSecondary>
                                <ButtonPrimary onClick={deleteAnswer} >{loadingAnswer ?
                                    <Loader
                                        type="Circles"
                                        color="white"
                                        height={25}
                                        width={25} /> : 'Yes'}</ButtonPrimary>
                            </div>
                        </div>
                    )}
                    onCloseModal={() => {
                        setLoadingAnswer(false);
                        setOpenModalConfirmationDelete(null)
                    }}
                />
            </div>
        )
    }




    const guideProfileGuideRender = () => {
        return (<div className=" listingSection__wrap">

            <div className="space-y-8">
                <FormItem
                    label={t('name') + "*"}
                    desc={t('name_desc')}
                >
                    <Input placeholder={t('name')} defaultValue={agencyName} onChange={(e) => setAgencyName(e.target.value)} />
                </FormItem>
                <FormItem
                    label={t('phone_number') + "*"}
                    desc={t('phone_number_desc')}
                >
                    {/* <Input placeholder="Phone number" onChange={(e) => setPhoneNumber(e.target.value)} /> */}
                    <PhoneInput
                        international
                        // defaultCountry="ID"
                        // onCountryChange={(con) => console.log(con)}
                        value={phoneNumberGuide}
                        onChange={phone => {
                            let ph = phone;
                            // console.log(phone);
                            setphoneFormatGuide(phone);
                            // if (value) {
                            //   console.log(parsePhoneNumber(value));
                            // }
                        }}
                    />
                </FormItem>


                <FormItem
                    label={t('id_card_') + "*"}
                    desc={t('id_card_desc')}
                >
                    <Input placeholder="Id card number" defaultValue={idCard} onChange={(e) => setIdCard(e.target.value)}
                    />
                </FormItem>
                <FormItem
                    label={t('bank_name') + "*"}
                    desc={t('bank_name_desc')}
                >
                    <Input placeholder={t('bank_name')} defaultValue={bankName} onChange={(e) => setBankName(e.target.value)} />
                </FormItem>
                <FormItem
                    label={t('acc_holder')}
                    desc={t('acc_holder_desc')}
                >
                    <Input placeholder="Account holder name" defaultValue={accountHolder} onChange={(e) => setAccountHolder(e.target.value)} />
                </FormItem>
                <FormItem
                    label={t('swift_code') + "*"}
                    desc={t('swift_code_desc')}
                >
                    <Input placeholder="Swift Code" defaultValue={swiftCode} onChange={(e) => setSwiftCode(e.target.value)}
                    />
                </FormItem>
                <FormItem
                    label={t('bank_no') + "*"}
                    desc={t('bank_no_desc')}
                >
                    <Input placeholder={t('bank_no')} defaultValue={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} />
                </FormItem>
                <FormItem
                    label={t('iban')}
                    desc={t('iban_desc')}
                >
                    <Input placeholder="IBAN" defaultValue={iban} onChange={(e) => setIban(e.target.value)}
                    />
                </FormItem>

                <div>
                    <div className="mt-5 ">
                        <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md">
                            <div className="space-y-1 text-center">
                                {loading === "imageID" ?
                                    <div className="flex mb-2  justify-center">
                                        <Loader
                                            type="Circles"
                                            color="#d24e29"
                                            height={25}
                                            width={25}
                                        />
                                    </div>
                                    :

                                    idCardImage ?
                                        <div className={`nc-NcImage h-28 mb-2`}>
                                            <img
                                                className={`inset-0 w-full h-full object-cover rounded-lg `}
                                                src={getUrl(idCardImage)}
                                                alt="ID CARD"
                                            />
                                        </div>
                                        :
                                        <svg
                                            className="mx-auto h-12 w-12 text-neutral-400"
                                            stroke="currentColor"
                                            fill="none"
                                            viewBox="0 0 48 48"
                                            aria-hidden="true"
                                        >
                                            <path
                                                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            ></path>
                                        </svg>
                                }
                                <label
                                    htmlFor="file-upload"
                                    className="relative cursor-pointer  rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                                >
                                    <span>{t('upload_image') + "*"}</span>
                                    <input
                                        id="file-upload"
                                        name="file-upload"
                                        type="file"
                                        className="sr-only"
                                        onChange={(event) => uploadID(event)}
                                    />
                                </label>
                                <p className="text-xs text-neutral-500 dark:text-neutral-400">
                                    PNG, JPG, GIF (Passport / National ID)
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="mt-5 ">
                        <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md">
                            <div className="space-y-1 text-center">
                                {loading === "uploadSelfieID" ?
                                    <div className="flex mb-2  justify-center">
                                        <Loader
                                            type="Circles"
                                            color="#d24e29"
                                            height={25}
                                            width={25}
                                        />
                                    </div>
                                    :

                                    idCardSelfie ?
                                        <div className={`nc-NcImage h-28 mb-2`}>
                                            <img
                                                className={`inset-0 w-full h-full object-cover rounded-lg `}
                                                src={getUrl(idCardSelfie)}
                                                alt="ID SELFIE CARD"
                                            />
                                        </div>
                                        :
                                        <svg
                                            className="mx-auto h-12 w-12 text-neutral-400"
                                            stroke="currentColor"
                                            fill="none"
                                            viewBox="0 0 48 48"
                                            aria-hidden="true"
                                        >
                                            <path
                                                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            ></path>
                                        </svg>
                                }
                                <label
                                    htmlFor="file-upload-selfie"
                                    className="relative cursor-pointer  rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                                >
                                    <span>{t('upload_image') + "*"}</span>
                                    <input
                                        id="file-upload-selfie"
                                        name="file-upload-selfie"
                                        type="file"
                                        className="sr-only"
                                        onChange={(event) => selfieIDUpload(event)}
                                    />
                                </label>
                                <p className="text-xs text-neutral-500 dark:text-neutral-400">
                                    PNG, JPG, GIF (Selfie dengan Paspor/ National ID)
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-end space-x-5 mt-3">
                <ButtonPrimary onClick={submitData} >
                    {loading === "submit" ? <div className="flex justify-center">
                        <Loader
                            type="Circles"
                            color="#fff"
                            height={25}
                            width={25}
                        />
                    </div> : t('save')}

                </ButtonPrimary>
            </div></div>);
    }

    return (
        <div className={`nc-AuthorPage ${className}`} data-nc-id="AuthorPage">
            <NcModal
                isOpenProp={showConfirmation}
                renderTrigger={() => { return (<div></div>); }}
                renderContent={() => {
                    return (
                        <div className="max-w-md">
                            <p className="text-center font-regular ">
                                {t('logout_confirm')}
                            </p>
                            <div className="flex justify-center space-x-5 mt-8">
                                <ButtonSecondary onClick={() => setShowConfirmation(false)} >{t('no')}</ButtonSecondary>
                                <ButtonPrimary onClick={() => {
                                    setShowConfirmation(false);
                                    logout();
                                }}
                                >{t('yes')}
                                </ButtonPrimary>
                            </div>
                        </div>
                    )
                }}
                hideCloseBtn={true}
                // contentExtraClass="w-1/4"
                modalTitle={t('logout')}
            />
            <Helmet>
                <title>{user.credential?.profile?.displayName}</title>
            </Helmet>
            <main className="container md:mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
                <div className="hidden md:block flex-grow mb-24 lg:mb-0">
                    <div className="lg:sticky lg:top-24">{renderSidebar()}</div>
                </div>
                <div className="w-full lg:w-3/5 xl:w-2/3 md:space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
                    {parseInt(user.credential?.isGuide) === 1 ? renderSection1(tabsIndex) : renderSection2()
                        // (<div className="listingSection__wrap">
                        //     <div>
                        //         <h2 className="text-2xl font-semibold">{t('welcome_back')}</h2>
                        //         <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                        //             {user.credential?.profile?.displayName},  {t('manage_ur_profile')}
                        //         </span>
                        //     </div>
                        //     <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

                        //     <div>
                        //         <Tab.Group>
                        //             <Tab.List className="flex space-x-1 overflow-x-auto">
                        //                 {["Trips", "Profile"].map((item) => (
                        //                     <Tab key={item} as={Fragment}>
                        //                         {({ selected }) => (
                        //                             <button
                        //                                 className={`flex-shrink-0 block !leading-none font-medium px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize rounded-full focus:outline-none ${selected
                        //                                     ? "bg-secondary-900 text-secondary-50 "
                        //                                     : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                        //                                     } `}
                        //                             >
                        //                                 {item}
                        //                             </button>
                        //                         )}
                        //                     </Tab>
                        //                 ))}
                        //             </Tab.List>
                        //             <Tab.Panels>
                        //                 <Tab.Panel className="">
                        //                     <MyTrips />
                        //                 </Tab.Panel>
                        //                 <Tab.Panel className="">
                        //                     <div className="mt-8 ">
                        //                         {guideProfileRender()}
                        //                     </div>
                        //                 </Tab.Panel>
                        //             </Tab.Panels>
                        //         </Tab.Group>
                        //     </div>
                        // </div>)
                    }
                    {/* {renderSection2()} */}
                </div>

            </main>
            <NcModal
                isOpenProp={general.alert.show}
                renderTrigger={() => { return (<div></div>); }}
                renderContent={() => { return general.alert.content; }}
                onCloseModal={() => {
                    dispatch(showAlert("", "", false))
                }}
                modalTitle={general.alert.title}
            />
            <ToastContainer position="bottom-right" />
        </div>
    );
};

export default PageProfile;
